/* eslint-disable @reatom/unit-naming-rule */
import { useAtom } from '@reatom/npm-react'
import { useMemo } from 'use-memo-one'

import { reatomImage } from '@root/shared/lib'

import { reatomCurrencyIcon } from '../../atoms'

import type { CurrencyModel } from '../../model'

export const useCurrencyIcon = ({
  currency,
  iconSrcOverride,
}: {
  currency: CurrencyModel
  iconSrcOverride?: string
}) => {
  const model = useMemo(() => {
    return iconSrcOverride
      ? reatomImage({ src: iconSrcOverride })
      : reatomCurrencyIcon({ currency })
  }, [currency, iconSrcOverride])
  const [state] = useAtom(model)

  return {
    state,
  }
}
